module.exports = __webpack_public_path__ + "static/media/pin_convenzionate_axa_highlighted.1d456ec4.png";